// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__u1VGG","title":"ClientCherryInfo_title__10e9z","itemText":"ClientCherryInfo_itemText__2dGCp"};